export { TextStyles } from './Text.Styled'
export { Text } from './Text'
